import { Avatar, Space } from "antd";

import { UserOutlined } from "@ant-design/icons";
import { EditIcon } from "../assets";
import { useAppSelector } from "../redux/hooks";
import moment from "moment";
import { IconPrimary } from "../components";
import { getAuthState } from "../redux/store/getState";
import capitalizeFirstLetter from "../utils/capitalizeFirstLetter";
import useUser from "../hooks/useUser";

export default function Profile() {
  const { user } = useUser();
  const { userType } = useAppSelector(getAuthState);
  return (
    <div className="profile_container">
      <div className="profile_section">
        <Space size={"large"}>
          <div className="profile_pic">
            <Avatar size={100} icon={<UserOutlined />} />
            <IconPrimary>
              <EditIcon />
            </IconPrimary>
          </div>
          <h4>{user?.username}</h4>
        </Space>
      </div>
      <div className="profile_section">
        <table>
          <tbody>
            <tr>
              <td>Email</td>
              <td>{user && user.email}</td>
            </tr>
            <tr>
              <td>Assigned Role:</td>
              <td>{capitalizeFirstLetter(userType)}</td>
            </tr>
            <tr>
              <td>Date of Onboarding:</td>
              <td>{user && moment(user.created_at).format("DD/MM/YYYY")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
